module.exports = __webpack_public_path__ + "build/assets/Aleo-Regular-590f2b00b056cc30c70a5d7f05005f61.woff";